var lists_default = {
  "fontElementMap": "_09VQj",
  "orderedlist": "cb8Me",
  "bulletedlist": "hNyvo",
  "listItem": "q-8IS"
};
export {
  lists_default as default
};
//# sourceMappingURL=lists-scss.js.map
